export default __webpack_public_path__ + "static/bj-35e2822357fa858edac7d848b3764c36.svg";